// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const ConvertCardIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "ConvertCard/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M18.333 12.5a5.829 5.829 0 0 1-5.833 5.833l.875-1.458M1.667 7.5A5.83 5.83 0 0 1 7.5 1.667l-.875 1.458"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18.333 3.5v.092a.413.413 0 0 1-.416.416h-7.5A.413.413 0 0 1 10 3.592V3.5c0-1.467.367-1.833 1.85-1.833h4.633c1.484 0 1.85.366 1.85 1.833ZM10.417 4.842a.413.413 0 0 0-.417.416V6.917c0 1.466.367 1.833 1.85 1.833h4.633c1.484 0 1.85-.367 1.85-1.833V5.258a.413.413 0 0 0-.416-.416h-7.5ZM10 13.083v.092a.413.413 0 0 1-.417.417h-7.5a.413.413 0 0 1-.416-.417v-.092c0-1.466.366-1.833 1.85-1.833H8.15c1.483 0 1.85.367 1.85 1.833ZM2.083 14.425a.413.413 0 0 0-.416.417V16.5c0 1.467.366 1.833 1.85 1.833H8.15c1.483 0 1.85-.366 1.85-1.833v-1.658a.413.413 0 0 0-.417-.417h-7.5Z"
}));
export default ConvertCardIcon;